'use strict';
const angular = require('angular');
const $ = require("jquery");

export default angular.module('conduu.ap.components.inplaceEditHover', [])
  .directive('inplaceEditHover', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {

        $(element).hover(function(){
            var preventBehaviour = $(this).hasClass("inplace-edit-hover-disabled");
            var editOnLabel = $(this).hasClass("inplace-edit-hover-on-label");

             if (!preventBehaviour) {
               if (editOnLabel) {
                 $(this).css('cursor', 'pointer').append("<span class='inplace-edit label label-default' style='margin-left:4px; margin-top:2px; position:absolute;'><i class='fa fa-pencil fa-2x'></i></span>");
               } else {
                 $(this).css('cursor', 'pointer').append("<i class='fa fa-pencil' style='padding-left:4px; position:absolute;'></i>");
               }
             }
          }, function(){
             var editOnLabel = $(this).hasClass("inplace-edit-hover-on-label");
             if (editOnLabel) {
               $(this).css('cursor','').children("span.inplace-edit").remove();
             } else {
               $(this).css('cursor','').children("i").remove();
             }
          });
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/inplace-edit-hover/inplace-edit-hover.directive.js